import axios from "axios";
import { errorHandler } from "@/Services/errorHandler";
import queryStringify from "qs-stringify";

// Centralized cleanup for API query parameters to avoid sending undefined/null/empty values
/**
 * Clean a query/payload object before serializing to a URL.
 * - Trims string values and drops empty strings, 'undefined', and 'null'.
 * - Removes null, undefined, NaN, and non-finite numbers.
 * - Keeps booleans as-is.
 * - Keeps non-empty arrays.
 * - Skips nested objects by default to avoid accidental serialization.
 *
 * @param {Record<string, any>} obj - Raw query object built from user inputs and timeline.
 * @returns {Record<string, any>} - Sanitized object safe for qs-stringify.
 */
const cleanQuery = (obj) => {
  if (!obj || typeof obj !== "object") return {};
  const out = {};
  Object.keys(obj).forEach((key) => {
    const val = obj[key];
    if (val === null || val === undefined) return;
    if (typeof val === "string") {
      const v = val.trim();
      if (!v || v.toLowerCase() === "undefined" || v.toLowerCase() === "null") return;
      out[key] = v;
      return;
    }
    if (typeof val === "number") {
      if (!isFinite(val) || Number.isNaN(val)) return;
      out[key] = val;
      return;
    }
    if (typeof val === "boolean") {
      out[key] = val;
      return;
    }
    if (Array.isArray(val)) {
      if (val.length > 0) out[key] = val;
      return;
    }
    // For plain objects or other types, skip by default to avoid accidental serialization
  });
  return out;
};

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getSupervisorData: async (context, data) => {
      let route = data.route;
      let query = data.query;
      let payload = cleanQuery({
        ...query,
        ...context.getters.getTimeFrame,
      });
      let stores = JSON.parse(localStorage.getItem(`stores`));
      let store = JSON.parse(localStorage.getItem(`selected_store`));

      if (stores.length === 0) return;
      let group = stores[0].Group;
      let storeDB = store.StoreDB;

      let headers = {
        group: window.btoa(group),
        DB: storeDB !== null ? window.btoa(storeDB) : null,
      };
      const queryString = `?` + queryStringify(payload);
      return axios
        .get(reportsApi + `${route}` + queryString, {
          headers,
        })
        .then(({ data }) => {
          return data;
        })
        .catch((err) => errorHandler.tomcatError(err));
    },
    getCashUpsData: async (context, data) => {
      let route = data.route;
      let query = data.query;

      let payload = cleanQuery({
        ...context.getters.getTimeFrame,
        ...query,
      });

      let stores = JSON.parse(localStorage.getItem(`stores`));
      let store = JSON.parse(localStorage.getItem(`selected_store`));

      if (stores.length === 0) return;
      let group = stores[0].Group;
      let storeDB = store.StoreDB;

      let headers = {
        group: window.btoa(group),
        DB: storeDB !== null ? window.btoa(storeDB) : null,
      };

      const queryString = `?` + queryStringify(payload);
      return axios
        .get(reportsApi + `${route}` + queryString, {
          headers,
        })
        .then(({ data }) => data)
        .catch((err) => errorHandler.tomcatError(err));
    },
    getCashUpData: async (context, data) => {
      let route = data.route;
      let query = data.query;

      let payload = cleanQuery({
        // ...context.getters.getTimeFrame,
        ...query,
      });
      console.log("payload:", payload);
      let stores = JSON.parse(localStorage.getItem(`stores`));
      let store = JSON.parse(localStorage.getItem(`selected_store`));

      if (stores.length === 0) return;
      let group = stores[0].Group;
      let storeDB = store.StoreDB;

      let headers = {
        group: window.btoa(group),
        DB: storeDB !== null ? window.btoa(storeDB) : null,
      };

      const queryString = `?` + queryStringify(payload);
      return axios
        .get(reportsApi + `${route}` + queryString, {
          headers,
        })
        .then(({ data }) => data)
        .catch((err) => errorHandler.tomcatError(err));
    },
  },
};
